module.exports = __webpack_public_path__ + "static/a-xx-229-art-3a1a87a9d977c57a012af4cc39472a2f.jpg";